<template>
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M576 96v709.568L333.312 562.816A32 32 0 1 0 288 608l297.408 297.344A32 32 0 0 0 640 882.688V96a32 32 0 0 0-64 0z"/></svg>
</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconSortDown',
} as DefineComponent
</script>